module.exports = __webpack_public_path__ + "static/image-carrusel-hunting-4-631a079d0cd85e24e5f9e4be445a8126.png";